export const hideUnhideSong = async (songId, request) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
    },
  }
  const route = "/song/" + songId + "/" + request

  const result = await fetch(route, requestOptions)

  mm.user.fetchUserSongs()
  return result
}

export const favoriteUnfavoriteSongVersion = async (songVersionId, request) => {
  const requestOptions = {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
      "Content-Type": "application/json",
    },
  }
  var route = "/favorites/" + request + "/song_version/" + songVersionId
  const result = await fetch(route, requestOptions)
  mm.user.fetchUserSongs()
  return result
}
